import type { OptionItem } from './OptionGroup';

import { getLetterSizeRank, sortSizeFacetsCallback } from '~/utilities/helpers';

export type SizeCategory = 'numeric' | 'letter' | 'country' | 'years' | 'jp' | 'ranges' | 'special';

export type SizeGroups = {
  numeric: OptionItem[];
  ranges: OptionItem[];
  letter: OptionItem[];
  country: OptionItem[];
  years: OptionItem[];
  jp: OptionItem[];
  special: OptionItem[];
};

export const categorizeSizeItem = (label: string): SizeCategory => {
  const trimmed = label.trim();
  const lowerLabel = trimmed.toLowerCase();

  if (
    lowerLabel === 'one size' ||
    lowerLabel === 'onesize' ||
    lowerLabel === 'os' ||
    lowerLabel === 'o/s' ||
    lowerLabel === '1size' ||
    lowerLabel === 'tu' ||
    lowerLabel.includes('one size')
  ) {
    return 'special';
  }

  if (
    lowerLabel.includes('(years)') ||
    lowerLabel.includes('years') ||
    /\b\d+\s*-\s*\d+\s*(m|y|yrs|months)\b/i.test(lowerLabel)
  ) {
    return 'years';
  }

  if (lowerLabel.includes('jp') && lowerLabel.includes('cm')) {
    return 'jp';
  }

  if (
    lowerLabel.includes(' gb ') ||
    lowerLabel.includes('(gb ') ||
    lowerLabel.includes(' us ') ||
    lowerLabel.includes('(us ') ||
    lowerLabel.includes(' eu ') ||
    lowerLabel.includes('(eu ') ||
    /^\d+\s+\(\d+\)$/.test(trimmed) ||
    /^\d+\s+\(\d+\s+cm\)$/i.test(trimmed) ||
    /^\d+\s*\[\d+\]$/.test(trimmed)
  ) {
    return 'country';
  }

  if (trimmed.includes('-') || /^[a-z0-9]+\s*[/-]\s*[a-z0-9]+$/i.test(trimmed)) {
    return 'ranges';
  }

  if (getLetterSizeRank(trimmed) !== undefined) {
    return 'letter';
  }

  return 'numeric';
};

export const groupSizeItems = (items: OptionItem[]): SizeGroups => {
  const groups: SizeGroups = {
    numeric: [],
    ranges: [],
    letter: [],
    country: [],
    years: [],
    jp: [],
    special: [],
  };

  items.forEach(item => {
    const category = categorizeSizeItem(item.label);

    groups[category].push(item);
  });

  const sortItems = (list: OptionItem[]) => {
    list.sort((a, b) => sortSizeFacetsCallback({ name: a.label }, { name: b.label }));
  };

  sortItems(groups.numeric);
  sortItems(groups.ranges);
  sortItems(groups.letter);
  sortItems(groups.country);
  sortItems(groups.years);
  sortItems(groups.jp);
  sortItems(groups.special);

  return groups;
};

export const SIZE_GROUP_ORDER: readonly SizeCategory[] = [
  'years',
  'country',
  'numeric',
  'ranges',
  'letter',
  'jp',
  'special',
] as const;
